import {
    getAccessToken,
    getLocalStorage,
    getRefreshToken,
    removeLocalStorage,
    setLocalStorage,
} from "../utils/common";
import {createContext, useContext, useState} from "react";
import axios from "axios";
import * as API from "../utils/api";

const authContext = createContext();

export function AuthProvider({ children }) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
    return useContext(authContext);
};

export const useProvideAuth = () => {

    const [access_token, setAccessToken] = useState(getAccessToken())
    const [refresh_token, setRefreshToken] = useState(getRefreshToken())
    const [user, setUser] = useState(getLocalStorage('user'))
    const [isAuthenticated, setAuthenticated] = useState(getAccessToken() != null)

    const saveAuth = (access, refresh, username) => {
        setAccessToken(access)
        setRefreshToken(refresh)
        setUser(username)
        setLocalStorage('access_token', access)
        setLocalStorage('refresh_token', refresh)
        setLocalStorage('user', username)
        setAuthenticated(true)
    }

    const login = (body, onSuccess, onError) => {
        axios.post(API.LOGIN_API, body)
        .then(data => {
            saveAuth(data.data.access, data.data.refresh, body.username)
            onSuccess()
        }).catch((error) => {
            console.log({error})
            onError(error)
        })

    }

    const logout = () => {
        setAuthenticated(false)
        setAccessToken(null)
        setRefreshToken(null)
        removeLocalStorage('access_token')
        removeLocalStorage('refresh_token')
        removeLocalStorage('user')
    }

    return {
        access_token,
        refresh_token,
        user,
        isAuthenticated,
        login,
        logout,
        saveAuth
    }
}